import React from 'react';
import { useAnalytics } from '../../utils/analytics-provider/analytics-provider';

import { Wrapper, LinkWrapper, StyledIconRightCaret } from './styles';

const Breadcrumb = ({ name, url }) => {
  const { trackEvent } = useAnalytics();

  const onLinkClick = ({ to }) => {
    trackEvent('content_engagement_v2', { engagement_type: 'breadcrumb_link_click', link: to });
  };

  return (
    <Wrapper>
      <LinkWrapper to="/" onClick={() => onLinkClick({ to: '/' })}>
        Support Center <StyledIconRightCaret />{' '}
      </LinkWrapper>

      <LinkWrapper to={`/${url}`} onClick={() => onLinkClick({ to: url })}>
        <b>{name}</b>
      </LinkWrapper>
    </Wrapper>
  );
};

export default Breadcrumb;
